import { render, staticRenderFns } from "./operator.vue?vue&type=template&id=2512edba&scoped=true"
import script from "./operator.vue?vue&type=script&lang=js"
export * from "./operator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512edba",
  null
  
)

export default component.exports